"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationSwimmingPool = function IllustrationSwimmingPool() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    d: "M52.5 48.5v-10c-.833.5-2 1.5-4 1.5-4 0-4.5-3-8-3S36 40 33 40c-4 0-5.5-3-8-3s-5.5 3-8 3c-1.2 0-3.667-1-4.5-1.5v10c.167.5 2 1.5 4 1.5 3.5 0 5-2.5 8.5-2.5s3.5 2.5 8 2.5c3.5 0 4.5-2.5 7.5-2.5s4 2.5 8 2.5c2 0 3.5-1 4-1.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.275",
    d: "M29.168 32.148h12.748M29.168 27.049h12.748M29.168 21.95h12.748M23.218 16h2.55a3.4 3.4 0 013.4 3.4v19.548M35.967 16h2.55a3.4 3.4 0 013.4 3.4v17.848M12.537 48.558c2.75 1.896 6.035 1.895 8.785 0 2.144-1.48 4.707-1.48 6.854 0 1.374.949 2.883 1.423 4.391 1.422 1.508 0 3.017-.474 4.392-1.422 2.147-1.481 4.71-1.48 6.855 0 2.748 1.896 6.034 1.897 8.784 0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.275",
    d: "M12.537 38.359c2.75 1.896 6.035 1.895 8.785 0 2.144-1.481 4.707-1.481 6.854 0 1.374.948 2.883 1.423 4.391 1.422 1.508 0 3.017-.474 4.392-1.422 2.147-1.482 4.71-1.48 6.855 0 2.748 1.896 6.034 1.897 8.784 0M12.537 43.458c2.75 1.897 6.035 1.896 8.785 0 2.144-1.48 4.707-1.48 6.854 0 1.374.949 2.883 1.423 4.391 1.423s3.017-.474 4.392-1.423c2.147-1.48 4.71-1.48 6.855 0 2.748 1.896 6.034 1.897 8.784 0"
  }));
};

var _default = IllustrationSwimmingPool;
exports.default = _default;